import React from 'react';
import {noop} from 'lodash';

import RecordsScreen from '/component/layout/RecordsScreen';
import {CLIENT_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_CONTENT_ORDER_HISTORY} from '/enum/reportCard.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import withRecordPopover from '../withRecordPopover';

import {AllGen0ClientsContent} from './AllGen0ClientsContent';
import reportPayload from './reportPayload';
interface Props {
  tt: (key: string, defaultValue?: string) => string;
  showRecordPopover: () => void;
  loadingData: {
    total?: number;
  };
}

export const AllGen0ClientsReport = ({
  tt = (key: string, defaultValue?: string) => defaultValue || '',
  showRecordPopover = noop,
  loadingData = {},
}: Props) => {
  return (
    <RecordsScreen
      {...reportPayload}
      title={tt('title', 'All Generation 0 Clients')}
      description={tt(
        'description',
        'All Clients in your Generation Zero (may be your personal Client or Clients of Coaches on your team).',
      )}
      contentProps={{loadingData, showRecordPopover}}
      contentComponent={AllGen0ClientsContent}
    />
  );
};

export default withHOC(
  withTranslation('report.allGen0Clients'),
  withRecordPopover({
    reportPayload,
    popoverName: CLIENT_REPORT,
    popoverContentName: REPORT_CARD_CONTENT_ORDER_HISTORY,
    popoverContentProps: {
      renderTitle: () =>
        withTranslation.ts('reportRecordTitle.orderHistory', 'Order History'),
    },
  }),
)(AllGen0ClientsReport);
